import { styled, Typography } from '@mui/material';

interface InputFieldProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  errorMessage?: string;
}

export const InputField = ({ errorMessage, ...props }: InputFieldProps) => {
  return (
    <>
      <TextContainer errorMessage={errorMessage} {...props} />
      {errorMessage && (
        <Typography variant="subtitle1" color="error">
          {errorMessage}
        </Typography>
      )}
    </>
  );
};

const TextContainer = styled('input')<InputFieldProps>(
  ({ theme, errorMessage }) => ({
    all: 'unset',
    boxSizing: 'border-box',
    padding: '8px 12px',
    height: '36px',
    backgroundColor: errorMessage
      ? theme.palette.mode === 'dark'
        ? '#1d1412'
        : '#fffcfc'
      : theme.palette.mode === 'dark'
      ? '#222'
      : '#17171707',
    borderRadius: '6px',
    border: `1px solid ${
      errorMessage
        ? theme.palette.mode === 'dark'
          ? '#7f2315'
          : '#f3b0a2'
        : theme.palette.divider
    }`,
    color: theme.palette.text.primary,
    fontSize: '14px',
    '&:disabled': {
      cursor: 'not-allowed',
      fontWeight: 400,
      opacity: 0.5,
      color: 'inherit',
    },
    '::placeholder': {
      color: errorMessage
        ? theme.palette.mode === 'light'
          ? '#fddcd7'
          : '#541c15'
        : theme.palette.mode === 'light'
        ? '#b2b2b2'
        : '#4d4d4d',

      opacity: 1, // Ensure visibility across browsers
    },
  })
);
